module.exports = __webpack_public_path__ + "img/Meat-Production.343d3950.png";